export function sanitizeInput(value: string, maxLen = 200): string {
  return value
    .replace(/[\u0000-\u001F\u007F]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, maxLen)
}

export function sanitizeEmail(value: string): string {
  return sanitizeInput(value, 254).toLowerCase()
}
